import { render, staticRenderFns } from "./AlarmsList.html?vue&type=template&id=2b3b8a86&scoped=true&external"
import script from "./AlarmsList.js?vue&type=script&lang=js&external"
export * from "./AlarmsList.js?vue&type=script&lang=js&external"
import style0 from "./AlarmsList.scss?vue&type=style&index=0&id=2b3b8a86&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3b8a86",
  null
  
)

export default component.exports